import React from "react";
import { Button, Divider, Popconfirm } from "antd";
import { useNavigate } from "react-router-dom";
import AppLayout, { Card } from "../components/Layout";
import ContactForm from "../components/ContactForm";
import httpClient from "../axios";
import { notifyError, notifySuccess } from "../helper";

const CreateContact = () => {
	const navigate = useNavigate();
	const http = React.useMemo(() => httpClient(), []);
	const [loading, setLoading] = React.useState(false);
	const [guestLoading, setGuestLoading] = React.useState(false);

	const onSubmit = (values) => {
		setLoading(true);
		http
			.post("/students", {
				name: values.name.trim(),
				email: values.email.trim(),
				phone_number: values.phone_number || null,
			})
			.then((response) => {
				notifySuccess("Contact added", `${response.data.data.name} is ready to start an experience.`);
				navigate("/users/students");
			})
			.catch((error) => notifyError(error, "Could not add the contact"))
			.finally(() => setLoading(false));
	};

	const createGuest = () => {
		setGuestLoading(true);
		http
			.post("/students/guest-students", { event_type: "medical_admin" })
			.then((response) => {
				notifySuccess("Guest contact created", `Guest ID ${response.data.data.name}`);
				navigate("/users/students");
			})
			.catch((error) => notifyError(error, "Could not create a guest contact"))
			.finally(() => setGuestLoading(false));
	};

	return (
		<AppLayout title="Add contact" subtitle="Create a contact, then launch a scenario from the contacts list." narrow>
			<Card>
				<ContactForm
					onSubmit={onSubmit}
					loading={loading}
					extra={
						<Button onClick={() => navigate("/users/students")}>Cancel</Button>
					}
				/>
				<Divider plain style={{ color: "var(--lcds-muted)" }}>
					or
				</Divider>
				<Popconfirm
					title="Create an anonymous guest contact with a generated ID?"
					okText="Create guest"
					onConfirm={createGuest}
				>
					<Button block loading={guestLoading}>
						Create guest contact (no details)
					</Button>
				</Popconfirm>
			</Card>
		</AppLayout>
	);
};

export default CreateContact;
